import { getLink } from "../../../utils/utils";

const content = {
  esp: (
    `

    <div class="poem">
      <p class="poem-block mb-3">
				Ho hispanino fiera, <br/>
				Brilo en flama rigard’! <br/>
				Ravas beleco supera, <br/>
				Movoj delogas kun ard’.
      </p>

      <p class="poem-block refreno mb-3">
        <span class="italic bold">Rf:</span> <br/>
        Mia kara, <br/>
				Vi estas senkompara! <br/>
				Mi atendas vin sub balkon’. <br/>
				Al vi flugas amor-kanzon’!
      </p>
			
      <p class="poem-block mb-3">
				Sonas la kant’ “segidilja”, <br/>
				Flagras pasio en kant’ <br/>
				Sub la ĉiel’ de Sevilja <br/>
				Amon deziras amant’
      </p>

      <p class="poem-block refreno mb-3">
        <span class="italic bold">Rf:</span> <br/>
        Mia kara, <br/>
				Vi estas senkompara! <br/>
				Mi atendas vin sub balkon’. <br/>
				Al vi flugas amor-kanzon’!
      </p>
			
      <p class="poem-block mb-3">
				Dancas “fandango” plej bele, <br/>
				Sekvas mi ŝin kun ador’. <br/>
				Jes, ŝi impresas fabele, <br/>
				Mia reĝino de l’ kor’! 
      </p>

      <p class="poem-block refreno mb-3">
        <span class="italic bold">Rf:</span> <br/>
        Mia kara, <br/>
				Vi estas senkompara! <br/>
				Mi atendas vin sub balkon’. <br/>
				Al vi flugas amor-kanzon’!
      </p>

    </div>
    `
  )
}

const itemName = {
  esp: 'Hispana Bolero'
}

const item = {
  itemlink: getLink(itemName.esp),
  esp: {
    itemName: itemName.esp,
    itemContent: content.esp,
    itemTranslator: `
      Muziko: Vincenzo Di Chiara, <br/>
      Traduko: T. Auderskaja
    `
  }
}

export default item;